import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { Page, Group, Layout, Button, Grid, ExcelUpload, FormControl, Table } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import { BASE, URLS, APIS, SF_LPCO_INFO_R, SG_LPCO_CPNT_LIST_R } from "./services/OsciCfgnCpntService";
import { CommonErrors } from "@/comn/components";

/*
 * @ 화면 컴포넌트 주석
 * @ 메타 시스템을 참고 하여 표준 단어와 용어를 사용하여 작성
 * @ !== ... ==! 치환 부호는 개발 완료 후 한글 주석을 인지하여 제거하기 위한 표시
 * @ 기본 여러줄의 주석 형태를 사용
 * @ 포맷
 * @ [화면명 영문]
 * @ [지환부호시작] [화면명 한글] [치환부호종료]
 *
 * 화면명 영문
 * !== 화면명 한글 ==!
 */

/*
 * Register LPCO Component
 * !== LPCO Component 등록 ==!
 */
export const OSCI0203003S = () => {
    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0116" },
            { area: "comnCd", comnCd: "OSC0100" },
            { area: "comnCd", comnCd: "OSC0125" },
            { area: "comnCd", comnCd: "OSC0113" },
            { area: "comnCd", comnCd: "OSC0114" },
            { area: "comnCd", comnCd: "OSC0025" },
            { area: "comnCd", comnCd: "OSC0126" },
        ],
    });
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { appFmId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const { openPopup } = usePopup();
    const [lpcoCpntList, setLpcoCpntList] = useState(comnUtils.getGridData([]));

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // LPCO Component Details !== LPCO Component 상세 ==!
        lpcoInfoDtl: useForm({
            defaultSchema: SF_LPCO_INFO_R,
            defaultValues: {},
        }),
    };
    const aprvNoPtnCd = form.lpcoInfoDtl.watch("aprvNoPtnCd");

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Component List !== Component 목록 ==!
        lpcoCpntList: useGrid({
            defaultSchema: SG_LPCO_CPNT_LIST_R,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const render = {
        grid_LpcoRList: {
            head: {},
            cell: {},
            edit: {
                // cpntNm: (props: any) => {
                //     const { binding, rowValues, value } = props;
                //     return (
                //         <FormControl
                //             type="select"
                //             options={[
                //                 { value: "GEN", label: "General Tab" },
                //                 { value: "TRN", label: "Transport Tab" },
                //                 { value: "INV", label: "Invoice Tab" },
                //                 { value: "ITM", label: "Item Tab" },
                //             ]}
                //             value={rowValues.cpntNm}
                //             onChange={(v) => {
                //                 let arrGridData = grid.lpcoCpntList.getData();
                //                 let objDuple;
                //                 if (arrGridData) {
                //                     objDuple = arrGridData.find((obj: any) => obj.cpntNm != "" && obj.cpntNm == v);
                //                 }
                //                 if (objDuple != null) {
                //                     modal.openModal({
                //                         title: "T_WARN",
                //                         content: "msg.osc.00002",
                //                     });
                //                 } else {
                //                     grid.lpcoCpntList.updateRow({ ...rowValues, cpntNm: v });
                //                 }
                //             }}
                //         />
                //     );
                // },
            },
        },
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        deleteAppCpnt: useFetch({
            api: (appFmId) => APIS.deleteAppCpnt(appFmId),
            onSuccess: () => {
                modal.openModal({
                    content: "msg.osc.00071",
                    onConfirm: () => {
                        navigate(URLS.osci0203002q);
                    },
                    onCancel: () => {
                        navigate(URLS.osci0203002q);
                    },
                });
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
            showToast: true,
        }),
        getAppDtl: useFetch({
            api: (data) => {
                return APIS.getAppDtl(data);
            },
            onSuccess: (data) => {
                console.log("getAppDtl onSuccess ==================== ", data);
                if (!data.appInfo.content.info || !data.appInfo.content.info?.appFmId) {
                    // no data
                    modal.openModal({
                        content: "msg.osc.00050",
                        onCancel: () => {
                            navigate(URLS.osci0203002q);
                        },
                    });
                } else {
                    form.lpcoInfoDtl.setValues(data.appInfo.content.info);
                    setLpcoCpntList(comnUtils.getGridData(data.appInfo.content.cpntList));
                }
            },
            onError: () => {},
            showToast: false,
        }),
    };

    /*
     * 화면에서 사용하는 이벤트, 함수를 선언
     * 기본 변수명은 메타 단어 조합 카멜 표기법을 따름
     * fetch 를 호출 하는 메소드: fetch 명과 동일하게 작성
     * 버튼이나 그리드의 이벤트의 경우 : [이벤트종류]_[이벤트대상타입]_[이벤트대상명]
     * 이벤트 대상 타입 : Btn , Grid ... 카멜표기법으로 표시, 첫글자 대문자
     * 이벤트 명 : 카멜표기법으로 표시, 첫글자 대문자
     *
     * const handler = {
     *      [handler 이름] : ()=>{ 함수 },
     *      click_Btn_Save : 저장버튼 클릭
     *      click_Grid_RpckItmAppList : 재포장 품목 신청서 그리드 클릭
     *      ...
     * }
     */
    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    // ORG LIST
    const [orgCdList, setOrgCdList] = useState([]);
    // ORG LPCO LIST
    const [orgLpcoList, setOrgLpcoList] = useState([]);

    const handler = {
        deleteAppCpnt: () => {
            modal.openModal({
                content: "msg.osc.00095",
                onConfirm: () => {
                    fetch.deleteAppCpnt.fetch(appFmId);
                },
            });
        },
        refreshOrgCdList: useCallback(async () => {
            setOrgCdList((await lpcoUtils.getOrgCdList()) || []);
        }, [orgCdList]),
        refreshOrgLpcoList: useCallback(
            async (usrOrgCd: any) => {
                setOrgLpcoList((await lpcoUtils.getOrgLpcoByPrcsList(usrOrgCd)) || []);
            },
            [orgLpcoList],
        ),
        setAppDtl: (appFmId: any) => {
            fetch.getAppDtl.fetch(appFmId);
        },
    };

    useEffect(() => {
        handler.setAppDtl(appFmId);
    }, []);

    return (
        <Page
        // id={pgeUid}
        // title={t("T_CPNT_FM_DTL")}
        // navigation={{
        //     base: comnEnvs.base,
        //     nodes: [
        //         ...BASE.nodes,
        //         { path: "/eswo/lpco/cfgn/cpnt/osci0203002q", label: "T_CPNT_FM_LST_SRCH" },
        //         { path: "/eswo/lpco/cfgn/cpnt/osci0203003s", label: "T_CPNT_FM_DTL" },
        //     ],
        // }}
        >
            <Group>
                <Group.Body>
                    <Group.Title title={"T_LPCO_APP_INFO"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.lpcoInfoDtl.schema.orgNm}></Group.Control>
                            <Group.Control {...form.lpcoInfoDtl.schema.appCdNo}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.lpcoInfoDtl.schema.appNm}></Group.Control>
                            <Group.Control {...form.lpcoInfoDtl.schema.appTpCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.lpcoInfoDtl.schema.appKndCd}></Group.Control>
                            <Group.Control {...form.lpcoInfoDtl.schema.atcmTpCd} controlSize={4}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Label label={"L_VLD_PRID"} required={false} />
                            <Group.Col padding={1}>
                                <Layout direction="row" gap={1}>
                                    <FormControl {...form.lpcoInfoDtl.schema.vldPridDays} />
                                    <FormControl {...form.lpcoInfoDtl.schema.daysUtCd} />
                                </Layout>
                            </Group.Col>
                            <Group.Control {...form.lpcoInfoDtl.schema.aprvNoPtnCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.lpcoInfoDtl.schema.useYn}></Group.Control>
                            {/* Pattern value only for pattern 009 !== 패턴값은 009일 때만 ==! */}
                            {aprvNoPtnCd === "009" && <Group.Control {...form.lpcoInfoDtl.schema.aprvNoPtnValue}></Group.Control>}
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.lpcoInfoDtl.schema.appImexTpCd}></Group.Control>
                            <Group.Control {...form.lpcoInfoDtl.schema.intfYn}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Title title={"T_CPNT"} titleSize={2}></Group.Title>
                    {/*
                     * 그리드
                     * @ 그리드 스키마 주입 : {...grid.[그리드이름].grid}
                     * @ 데이터 data={fetch.[fetch 명].data?.[api 리턴 vo 명]}
                     * @ 셀클릭이벤트 연결 : onCellClick={handler.[그리드 이벤트 핸들러명]}
                     */}
                    <Grid
                        {...grid.lpcoCpntList.grid}
                        data={lpcoCpntList} /* fetch.getRpckItmAppList.data?.lpcoCpntList */
                        render={render.grid_LpcoRList}
                        // onCellClick={handler.click_Grid_RpckItmAppList}
                        // onRowClick={handler.click_GridRow_RpckItmAppList}
                    />
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0203002q);
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    {/* <Button role="edit" onClick={handler.click_Btn_AddGridLpcoAtcdFileList}></Button> */}
                    <Button
                        role="edit"
                        onClick={() => {
                            navigate(`${URLS.osci0203004s}/${appFmId}`);
                        }}
                    ></Button>
                    <Button role="delete" onClick={handler.deleteAppCpnt}></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
